import { createSelector } from 'reselect';

export const getProductsState = state => state.products;
export const productSelector = state => state.products.list;
export const supplyReceiptsSelector = state => state.products.supplyreceipts;
export const productDetailSelector = state => state.products.detail;
export const supplyrReceiptDetailSelector = state => state.products.supplyreceiptdetail;
export const productTypesSelector = state => state.products.prodTypes;
export const productInfoSelector = state => state.products.prodInfo;
export const vendorSelector = state => state.products.vendorData;
export const vendorOrdersSelector = state => state.products.vendorOrdersData;
export const vendorAutoCompleteSelector = state => state.products.autocompleteVendor;
export const manufacturerSelector = state => state.products.manufacturerData;
export const manufacturerAutoCompleteSelector = state => state.products.autocompleteManufacturer;
export const productAutoCompleteSelector = state => state.products.autocompleteProduct;
export const filtersSelector = state => state.products.filters;
export const importInfoSelector = state => state.products.importinfo;
export const importProductsSelector = state => state.products.importproducts;
export const salesOrerSelector = state => state.products.salesorder;
export const salesOrderPageSelector = state => state.products.salesorderpage;
export const stockAlertSelector = state => state.products.stockalerts;
export const stockAlertRecipientSelector = state => state.products.stockalertrecipient;
export const freightAutoCompleteSelector = state => state.products.autocompleteFreight;
export const freightSelector = state => state.products.freightData;
export const stockSettingsSelector = state => state.products.stockSettings;
export const productsFileSelector = state => state.products.productsfile;
export const csvProductSelector = state => state.products.csvproduct;
export const importcsvProductSelector = state => state.products.importcsvproduct;

export const getProductsData = createSelector([getProductsState], products => products.list);

export const getProductList = createSelector(
  productSelector,
  list => list,
);

export const getSupplyReceipts = createSelector(
  supplyReceiptsSelector,
  supplyreceipts => supplyreceipts,
);

export const getProductDetail = createSelector(
  productDetailSelector,
  detail => detail,
);

export const getSupplyReceiptDetail = createSelector(
  supplyrReceiptDetailSelector,
  supplyreceiptdetail => supplyreceiptdetail,
);

export const getProductTypes = createSelector(
  productTypesSelector,
  prodTypes => prodTypes,
);

export const getProductInfo = createSelector(
  productInfoSelector,
  prodInfo => prodInfo,
);

export const getVendorData = createSelector(
  vendorSelector,
  vendorData => vendorData,
);

export const getVendorOrdersData = createSelector(
  vendorOrdersSelector,
  vendorOrdersData => vendorOrdersData,
);

export const getAutoCompleteVendor = createSelector(
  vendorAutoCompleteSelector,
  autocompleteVendor => autocompleteVendor,
);

export const getManufacturerData = createSelector(
  manufacturerSelector,
  manufacturerData => manufacturerData,
);

export const getAutoCompleteManufacturer = createSelector(
  manufacturerAutoCompleteSelector,
  autocompleteManufacturer => autocompleteManufacturer,
);

export const getAutoCompleteProduct = createSelector(
  productAutoCompleteSelector,
  autocompleteProduct => autocompleteProduct,
);

export const getFilters = createSelector(
  filtersSelector,
  filters => filters,
);

export const getimportInfo = createSelector(
  importInfoSelector,
  importinfo => importinfo,
);

export const getimportProducts = createSelector(
  importProductsSelector,
  importproducts => importproducts,
);

export const getSalesOrder = createSelector(
  salesOrerSelector,
  salesorder => salesorder,
);

export const getSalesOrderPage = createSelector(
  salesOrderPageSelector,
  salesorderpage => salesorderpage,
);

export const getStockAlerts = createSelector(
  stockAlertSelector,
  stockalerts => stockalerts,
);

export const getStockAlertRecipient = createSelector(
  stockAlertRecipientSelector,
  stockalertrecipient => stockalertrecipient,
);

export const getAutoCompleteFreight = createSelector(
  freightAutoCompleteSelector,
  autocompleteFreight => autocompleteFreight,
);

export const getfreightData = createSelector(
  freightSelector,
  freightData => freightData,
);

export const stockAlertSettingsData = createSelector(
  stockSettingsSelector,
  stockSettings => stockSettings,
);

export const getProductsFile = createSelector(
  productsFileSelector,
  productsfile => productsfile,
);

export const getCSVProduct = createSelector(
  csvProductSelector,
  csvproduct => csvproduct,
);

export const getImportCSVProduct = createSelector(
  importcsvProductSelector,
  importcsvproduct => importcsvproduct,
);
